// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { getToken, isTokenExpired } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
  const token = getToken();

  if (!token || isTokenExpired(token)) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
